//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"HeightZ",0,"Expression",0],[1,"LengthX",0,"Expression",0],[1,"LevelZ",0,"Expression",0],[0,"Loading",1,0],[0,"ObjectPosition",1,0],[0,"Position",1,0],[1,"Radius",0,"Expression",0],[0,"RequirementsControl",1,0],[0,"Shape",1,0],[0,"Standard",1,0],[0,"WheelSize",1,0],[1,"WidthY",0,"Expression",0]],[],[]];
SPLM.Features.VehicleDesign.WheelFixingBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.WheelFixingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.WheelFixingBuilder.RequirementsControlType = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.WheelFixingBuilder.PositionType = Object.freeze({
    "Front" : "Front", "Rear" : "Rear", "Both" : "Both"});

SPLM.Features.VehicleDesign.WheelFixingBuilder.WheelSizeType = Object.freeze({
    "StaticRadius" : "StaticRadius", "Diameter" : "Diameter"});

SPLM.Features.VehicleDesign.WheelFixingBuilder.ShapeType = Object.freeze({
    "Block" : "Block", "CircleSegment" : "CircleSegment"});

SPLM.Features.VehicleDesign.WheelFixingBuilder.ObjectPositionType = Object.freeze({
    "WheelExtents" : "WheelExtents", "WheelContact" : "WheelContact"});

export default SPLM;